export class StringServant {
  static build(): StringServant {
    return new StringServant();
  }

  toNumber(str: string): number {
    return _.reduce(
      str,
      (sum: number, letter: string): number => {
        sum += letter.charCodeAt(0);
        return sum;
      },
      0
    );
  }
  /*
  we can curry any method or now we can just use the method and it got easier to write/test
  const shouldUpdate = _.curry(pluralize)('single-text', 'plural-text')
  const finalValue = pluralize('single-text', 'plural-text', 2);
  */
  pluralize(singularText: string, pluralText: string): (changes: number) => string {
    return (changes: number): string => {
      return changes > 1 ? pluralText : singularText;
    };
  }
}



// WEBPACK FOOTER //
// ./app/lib/global/servants/string_servant.ts